var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pictures"},[_c('servicesList'),_c('ul',_vm._l((_vm.imgLists),function(n,i){return _c('li',{key:i},[_c('img',{attrs:{"src":_vm.weburl+ n.img,"alt":""}})])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }